export default __webpack_public_path__ + "static/media/Physics01_04.21f393a3.png";